<template>
  <div class="bg">
    <el-row>
    <el-col :offset="2" :span="20">
      <div class="upd">
          <div class="upbutton" style="cursor: pointer;" @click="showUpload">
              <img id="uploadicon" alt="uploadicon" src="../src/assets/upd.svg" >
              <div class="uploadtext" >上传文件</div>
          </div>
          <div class="uploadprompt">提供科学准确的视觉注意力预测、分析及展示服务</div>
      </div>
    </el-col>
    <el-dialog
               :visible.sync="uploadShow"
      width="50%"
      top="15vh"
      :before-close="handleClose" class="uploadpart">
      <div        v-loading="uploadLoading">
      <el-upload
        class="upload-demo"
        :file-list="fileList"
        ref="upload"
        :on-change="onchange"
        :show-file-list="false"
        :data="allFileData"
        :on-exceed="handleExceed"
        :accept="accept"
        drag
        action="/api/uploadfile/uploadFiles"
        :auto-upload="false"
        :limit="1"
        >
        <i class="el-icon-upload" style="color: #dc3526;font-size: 110px"></i>
        <div class="el-upload__text" style="color: #0f0f0f">拖放文件到这里或 <span style="color: #dc3526">点此选择文件</span>
          <div class="el-upload__tip" slot="tip">支持格式: JPG, JPEG, PNG</div>
        </div>

      </el-upload>
      <div style=";font-size:24px;font-family:PingFang SC;margin-top:10px;margin-bottom:10px ;" v-show="this.fileList.length!=0">{{result_state}}</div>
        <!--      <div class="upfile">-->
        <div>{{ tipMessage }}</div>
        <div v-for="(item,index) in fileList" class="upfile" >
        <el-col :span="10" class="flexw">
          <div style="margin-left: 5%;">{{ item.name }}</div>

        </el-col>
          <el-col :span="2" class="flexw">
            <div style="margin-left: 5%" v-if="item.size/1024/1024<1">{{ parseInt(item.size/1024 )}}KB</div>
            <div style="margin-left: 5%" v-else>{{ parseInt(item.size/1024/1024) }}MB</div>
          </el-col>
        <el-col :span="8" class="flexw">
          <div style="float:right;display: inline-block">
            <el-checkbox-group v-model="checkList" >
              <el-checkbox label="1">热点图预测</el-checkbox>
              <el-checkbox label="2">扫描路径预测</el-checkbox>
            </el-checkbox-group>
          </div>
        </el-col>
        <el-col :span="2" :offset="1"  class="flexw">
          <el-progress v-show="showProgress" type="circle" :width=50 v-if="!isNaN(parseInt(progressPercent))" :percentage="progressPercent>100? 100 : progressPercent" color="#dc3526"></el-progress>
          <div @click="openImg(fileNameList[index])" style="cursor: pointer" v-show="!showProgress">查看</div>
        </el-col>
      </div>
      <el-button v-show="this.fileList.length>0" style="background-color: #dc3526;border-color: #dc3526; margin-left: 10px;width: 30%;margin-top: 1vh" :disabled="uploadButton" type="success" @click="submitUpload">开始分析</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="imgshow" width="70%" :height="400" class="mydia" >
      <div style="height: 60vh" class="flexw">
        <img :src="imgShowUrl" style="max-width:100%;max-height:100%;border-radius: 1px;margin:auto"/>
      </div>
      <el-row>
        <el-col :offset="1" :span="22">
          <div style="height: 10vh;text-align: left">
            <el-radio-group v-model="tabPosition" style="margin-top: 10px;" @change="handleRadioChange">
              <el-radio-button label="left" v-if="imgInfo.hotStatus==1">热点图</el-radio-button>
              <el-radio-button label="right" v-if="imgInfo.pathStatus==1">扫描路径图</el-radio-button>
            </el-radio-group>
            <el-button ref="clipboard" v-clipboard:copy="copyText" @click="copysuc" class="share-button" icon="el-icon-share" type="info" style="float: right;margin-top: 10px;font-size: 15px">分享</el-button>
          </div>

        </el-col>

      </el-row>

    </el-dialog>
    </el-row>
    <el-row>
      <el-col :offset="2" :span="20" style="margin-top: 2vh;margin-bottom: 2vh;">
      <div id="example">案例展示</div>
      </el-col>
    </el-row>

<!--    <el-row>-->
<!--      <el-col :offset="2" :span="20">-->
<!--        <div style="height: 60vh;" class="pb">-->
<!--          <div class="infinite-list" style="overflow:auto;height: 100%" v-infinite-scroll="loadmore">-->
<!--            <el-col :span="25" class="infinite-list-item"  style="margin-bottom: 10px;" v-for="item in items" :key="item.id">-->
<!--              <div style="width: 100%;height:100%; ">-->
<!--                <div style="width: 95%;height:100%;margin: auto;box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)">-->
<!--                  <div style="width: 100%;aspect-ratio: 1/0.6" >-->
<!--                    <img :src="item.fileHotAddress"  style="max-width: 100%;max-height: 100%;border: 1px solid gray;">-->
<!--                  </div>-->
<!--                  <div style="height: 100%">-->
<!--                    <el-row style="height: 6vh">-->
<!--                      <el-col :span="15" :offset="1" class="flexw" style="height: 95%">-->
<!--                        <img :src="userAvatar" height="60%"-->
<!--                             style="border-radius: 50%;aspect-ratio: 1/1;">-->
<!--                        <div style="text-align: left;margin-left: 6px">-->
<!--                          <div style="font-size: 13px">{{ item.fileName|ellipsis }}</div>-->
<!--                          <div style="font-size: 10px">{{ item.userName }}</div>-->
<!--                        </div>-->
<!--                      </el-col>-->
<!--                      <el-col :span="8" style="text-align: left;height: 95%;font-size: 10px;color: gray" class="flexw">-->
<!--                        <img :src="loveIcon" height="20%" style="aspect-ratio: 1/0.9;" >-->
<!--                        <span>121</span>-->
<!--                        <img :src="lookIcon" height="20%" style="aspect-ratio: 1/0.7;margin-left: 10%;cursor: pointer" @click="showImgDetail(item.id)">-->
<!--                        <span>5.1k</span>-->
<!--                      </el-col>-->
<!--                    </el-row>-->
<!--                  </div>-->

<!--                </div>-->
<!--              </div>-->
<!--            </el-col>-->
<!--          </div>-->
<!--          <div v-loading="pbloading"     element-loading-text="拼命加载中"-->
<!--               element-loading-spinner="el-icon-loading" style="margin-top: 1px;"></div>-->
<!--        </div>-->
<!--      </el-col>-->
<!--    </el-row>-->

    <el-row>
      <el-col :offset="2" :span="20">
            <el-col :span="25"   style="margin-bottom: 10px;" v-for="item in items" :key="item.id">
              <div class="fileBox">
                <div style="padding-top: 70%;height:0;">
                  <div style="position: absolute;left: 0;top: 0;width: 100%;height: 100%">
                    <div style="height: 80%;background-color: #D9D9D9" >
                      <img :src="item.fileHotAddress" class="imgcl" @click="showImgDetail(item.id,1)" >
                    </div>
                    <div style="height: 19%">
                        <el-col :span="8" :offset="15" style="text-align: left;height: 95%;font-size: 10px;color: gray" class="flexw">
                          <img :src="loveIcon" height="30%"  >
                          <span>121</span>
                          <img :src="lookIcon" height="30%" style="margin-left: 10%;cursor: pointer" @click="showImgDetail(item.id,1)">
                          <span>5.1k</span>
                        </el-col>
                    </div>
                  </div>
                </div>
              </div>
            </el-col>
      </el-col>
    </el-row>
    <el-row>
      <el-col :offset="2" :span="20">
        <el-col :span="25"   style="margin-bottom: 10px;" v-for="item in items1" :key="item.id">
          <div class="fileBox">
            <div style="padding-top: 70%;height:0;">
              <div style="position: absolute;left: 0;top: 0;width: 100%;height: 100%">
                <div style="height: 80%;background-color: #D9D9D9" >
                  <img :src="item.filePathAdress" class="imgcl" @click="showImgDetail(item.id,2)" >
                </div>
                <div style="height: 19%">
                  <el-col :span="8" :offset="15" style="text-align: left;height: 95%;font-size: 10px;color: gray" class="flexw">
                    <img :src="loveIcon" height="30%"  >
                    <span>121</span>
                    <img :src="lookIcon" height="30%" style="margin-left: 10%;cursor: pointer" @click="showImgDetail(item.id,2)">
                    <span>5.1k</span>
                  </el-col>
                </div>
              </div>
            </div>
          </div>
        </el-col>
      </el-col>
    </el-row>

    <el-dialog :visible.sync="imgDetailShow" width="70%"   class="mydia" >
      <el-row>
        <el-col :offset="1" :span="22">
          <img v-if="pathShow==false" :src="imgDetail.fileHotAddress" style="max-width:100%;max-height: 100%;border: 1px solid gray;border-radius: 1px"/>
          <img v-if="pathShow==true" :src="imgDetail.filePathAdress" style="max-width:100%;max-height: 100%;border: 1px solid gray;border-radius: 1px"/>
        </el-col>
      </el-row>
      <el-row style="margin-top: 1%">
        <el-col :span="22" :offset="1" class="flexw">
          <el-col :span="20">
            <div style="float: left">{{ imgDetail.fileName }}</div>
          </el-col>
            <el-button class="lvue" style="float:right;">
              <i class="my-icon-love"></i> 喜欢
            </el-button>
            <el-button v-if="pathShow==false" v-clipboard:copy="copyText1" @click="copysuc1(domain+imgDetail.fileHotAddress)" class="share-button" icon="el-icon-share" type="info" style="font-size: 12px;float: right">分享</el-button>
            <el-button v-if="pathShow==true" v-clipboard:copy="copyText1" @click="copysuc1(domain+imgDetail.filePathAdress)" class="share-button" icon="el-icon-share" type="info" style="font-size: 12px;float: right">分享</el-button>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="22" :offset="1">
          <el-row style="text-align: left;margin-bottom: 1%;margin-top: 1%">描述说明</el-row>
          <div style="text-align: left;border: 1px solid gray;padding:2vh;margin-bottom: 30px;height: auto;border-radius: 2px">认知负荷计算结果：{{ randomCognitiveLoad }}（很低，低，中，高，很高），本次结果计算准确率：{{ randomAccuracy }}</div>
        </el-col>
      </el-row>


    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "index",
  mounted() {
    this.getFileList()
    // window.addEventListener( 'resize',this.handleResize);
    const currentHostname = window.location.hostname;
    const currentPort = window.location.port;
    this.domain="http://"+currentHostname+":"+currentPort
    if (!navigator.clipboard) {
      console.log('该浏览器不支持 Clipboard API');
    }
    let a=localStorage.getItem("userinfo")
    if (a!=undefined &&a!=null){
      this.userId=JSON.parse(localStorage.getItem('userinfo')).userId
    }
    // random
    //this.randomAccuracy = (Math.random() * (100 - 75) + 75).toFixed(1) + '%';
    //const cognitiveLoadOptions = ['很低', '低', '中', '高', '很高'];
    //this.randomCognitiveLoad = cognitiveLoadOptions[Math.floor(Math.random() * cognitiveLoadOptions.length)];
  },
  data() {
    return {
      randomAccuracy: null,
      randomCognitiveLoad: '',
      result_state:'文件信息',
      uploadShow:false,
      uploadLoading:false,
      uploadButton:false,//上传按钮点击
      upheight:60,
      fileList:[],
      fileListShow:[],
      checkList:['1'],
      allFileData:{},
      progressPercent:0,
      showProgress:true ,//展示进度条还是查看
      userId:"",
      //上传成功后不断做回传
      uploadSucc:false,
      tipMessage:"",
      timerInterVal:undefined,
      uploadInterVal:undefined,
      fileNameList:[],
      fileImgInfo:{},//上传解析后的图片列表信息
      imgInfo:{},//打开的图片信息
      imgshow:false,//是否显示图片图层
      imgShowUrl:"",
      tabPosition:"left",
      copyText: '这是需要复制的文本',
      copyText1: '这是需要复制的文本',
      domain:"",
    //  --------------主页展示内容
      loveIcon:"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAOCAYAAAAmL5yKAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAE1SURBVHgBnVPLcYMwFBSaXLhRglOB00FIBXE6MEegiJAKuPE5ya4gpgLcQeIK4nTgG3CB7DKPjDKJ48+bEZJWuys96eEoK/I899H5wzAcHMfZhGG4n3Bgd8A8TLfAt5PGEcIMnQGB0x0/EDyibbTWqu/7Jfq1GBOn0QM3uBGjGqR1HMfJ5JymaeK6bs0x+tsgCA6ylGBD8gxNxuMVRfGmjoQxxvsLh6amVkvO1TEDa+cfAQ1T9TXzwsBTVwS1GpfyjvFcXRjQ3Yt2fIUPecKzglxqONaCBWq8L3MyFeHwBV6+DaQwqq7rzCmDpmnIqaBZjanYi1mWrVAwc1zO01SF9s5t275i7TOKouWEa5vEBXnSGmYLZeUMMWtlZ4t/ncASkPSMthdohhbY/8BZQaOyLBf/cb4AoZaganmmKWIAAAAASUVORK5CYII=",
      lookIcon:"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAMCAYAAACEJVa/AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAFkSURBVHgBfVLLkYJAFGTwojdDIINlI1AjUCNQTv4uEoEagbsHf1wwAyUCCQEzYDPgQhUcgO2mmK1ZSnxVVM/0e69n6HlCa4jT6dQvisIUQnR1XQ9ms9m9qVa8aJ4CNmgOgU8IRVj3gAb218VisXsrAgEXDSYabBT7tRxFtsh/ID9GPvwn4rpuN03TR57nz06ns7YsK1JuxfBlE7gtYIJvIDkhbwB1sVwuZZN2Pp/3AN7qB9hrt9ufingpJDn9crnw/01VwHEcNo/m8zlPm9KfJElGMg+OIh44HqTpKO5nWeZptaChypoGd2t5H9CXIhaecMInlQVxHIcA43g8rit+iNvcVZOx38PDcSlCc6qNy98gadt2BPEBxclj/a0YawAe5FarVfBnLONwOJhoujEJf760F1EN4A3LnVpTnxODp1TbXavVCuAXvSG/qdCqz5BoOJEvMuTYl0V4Hfyyhxm6ymdW4xf+GdZJzvw+FQAAAABJRU5ErkJggg==",
      temp:"海报热点图预测图预测",
      userAvatar: require("@/assets/toux.jpeg"),
      currentPage: 0,
      pageSize: 25,
      total:0,
      items:[],
      items1:[],
      imgDetail:{},
      imgDetailShow:false,
      pathShow:false,//打开展示路径图
      accept: '.jpg,.jpeg,.png',
      pbloading:false//瀑布流的loading
    }
  },
  methods: {
    handleResize(){
      // location.reload()
    },
    handleExceed(files, fileList) {
      this.$message.warning(`只能上传一张图片`);
    },
    showUpload() {

      let a = localStorage.getItem("userinfo")
      if (a == null || a == undefined) {
        this.$message({
          message: "请先登录",
          duration: 1500,
          type: 'warning'
        });
        return
      }
      this.uploadShow = true
      // this.setDialogHeight()
    },
    handleClose() {
      this.uploadShow = false
      this.uploadButton = false
      this.showProgress = true
      this.fileList = []
      this.checkList=['1'],
      this.progressPercent=0
      this.flag=false
      this.fileNameList=[]
    },
    onchange(file, fileList) {
      this.fileList = fileList
    },
    async submitUpload() {


      if (this.fileList.length === 0) {
        this.$message.success("请上传文件");
        return;
      }

      // 1 热力模式 2 路径模式 3 双模式
      if (this.checkList.length > 1) {
        this.allFileData.type = 3
      } else if (this.checkList.length == 0) {
        this.$message({
          message: '请选择一种扫描模式',
          duration: 2000,
          type: 'warning'
        });
        return
      } else {
        let temp = this.checkList[0]
        temp == '1' ? this.allFileData.type = 1 : this.allFileData.type = 2
      }
      let formData = new FormData();
      this.fileList.forEach((file) => {
        formData.append("file", file.raw); // file.raw
      });
      formData.append('type', this.allFileData.type);
      formData.append('userId', this.userId);
      if (this.uploadLoading == false) {
        this.uploadLoading = true;
        //上传前检测是否存在已上传的数据
        let detectData = {}
        detectData.userId = this.userId
        let flag = false
        const detectRes = await this.$axios.post('/api/uploadfile/detectionUpload', detectData).then(res => {
          if (res.data.status != 0) {
            this.$message({
              message: res.data.message,
              duration: 2000,
              type: 'warning'
            });
            flag = true
          }
        })
        //上传按钮
        if (flag) {
          this.uploadLoading = false
          return
        }
        const res = await this.$utils.uploadFiles("/api/uploadfile/uploadFiles", formData).then(res => {
          if (res.data.status == 0) {
            this.$message({
              message: res.data.message,
              duration: 1000,
              type: 'success'
            });
            this.uploadSucc = true;
            this.uploadButton = true
            this.fileList.forEach((file) => {
              this.fileNameList.push(file.name)
            });
          } else {
            this.$message({
              message: res.data.message,
              duration: 2000,
              type: 'warning'
            });
            return false
          }
        })
          .catch(error => {
            this.$message.error('上传失败！');
            return false
          });
        this.uploadLoading = false
        if (res==false){
          return
        }
      }
        this.dealSubmit()
        this.uploadInterVal = setInterval(this.dealSubmit, 5000)



    },
    async dealSubmit() {
      let _this = this
      let flag = false
      let detectData = {}
      detectData.userId = this.userId
      await this.$axios.post('/api/uploadfile/dealUploadFiles', detectData).then(async res => {
        if (res.data.status == 20) {
          _this.tipMessage = res.data.message
        } else if (res.data.status == 0) {
          clearInterval(_this.uploadInterVal)
          clearInterval(_this.timerInterVal)
          this.timerInterVal = setInterval(this.getImgInfo, 50)
          flag = true

        } else if (res.data.status == 24) {
          clearInterval(_this.uploadInterVal)
          clearInterval(_this.timerInterVal)

          this.$message({
            message: res.data.message,
            duration: 2000,
            type: 'warning'
          });
          flag=true
        }else if (res.data.status == 23) {
          this.$message({
            message: res.data.message,
            duration: 2000,
            type: 'success'
          });
          //开始计时
          this.tipMessage = ""
          this.timerInterVal = setInterval(function () {
            if (_this.progressPercent == 98) {
              clearInterval(_this.timerInterVal)
            }
            _this.progressPercent = 1 + _this.progressPercent
          }, 1000)
        }
      })


    },
    openImg(fileName) {
      this.imgshow = true
      this.imgInfo = this.fileImgInfo[fileName]
      if (this.imgInfo.hotStatus == 1) {
        this.tabPosition = "left"
        this.imgShowUrl = this.imgInfo.fileHotAddress
        this.copyText = this.domain + this.imgShowUrl
      } else if (this.imgInfo.hotStatus != 1 && this.imgInfo.pathStatus == 1) {
        this.tabPosition = "right"
        this.imgShowUrl = this.imgInfo.filePathAdress
        this.copyText = this.domain + this.imgShowUrl
      }
    },
    handleRadioChange(val) {
      if (val == "left") {
        this.imgShowUrl = this.imgInfo.fileHotAddress

        this.copyText = this.domain + this.imgShowUrl

      } else {
        this.imgShowUrl = this.imgInfo.filePathAdress
        this.copyText = this.domain + this.imgShowUrl
      }
    },
    async getImgInfo() {
      let _this = this
      //发起请求获取图片地址位置-------------------------------------
      if (_this.progressPercent >= 98) {
        clearInterval(_this.timerInterVal)
      }
      _this.progressPercent = 1 + _this.progressPercent
      if (this.progressPercent == 98) {
        const datas = {}
        datas.userId = this.userId
        datas.fileNameList = this.fileNameList
        await this.$axios.post("/api/uploadfile/getSuccUploadFile", datas).then(res => {
          if (res.data.status == 0) {
            this.$message({
              message: res.data.message,
              duration: 2000,
              type: 'success'
            });
            this.fileImgInfo = res.data.data
          } else {
            this.$message({
              message: res.data.message,
              duration: 2000,
              type: 'warning'
            });
          }
        })
        this.progressPercent += 1
        this.showProgress = false
        this.result_state = '分析结果'
      }
    },
    copysuc() {
      this.$message({
        message: "复制路径成功",
        duration: 2000,
        type: 'success'
      });
    },
    copysuc1(data) {
      this.copyText1=data
      console.log(this.copyText1)
      this.$message({
        message: "复制路径成功",
        duration: 2000,
        type: 'success'
      });

    },
    // 将标题设置成10个字以内
    async getFileList() {
      let params = {}

      if (this.pbloading==false){
        this.pbloading=true
        this.currentPage += 1;
        params.currentPage = this.currentPage
        params.pageSize = this.pageSize
        params.hotStatus=1
        await this.$axios.post('/api/uploadfile/selectFileInfo', params).then(res => {
          if (res.data.status == 0) {
            this.items =[...this.items, ...res.data.data.files]
            this.total = res.data.total
            if (res.data.data.files.length == 0) {
              this.$message({
                message: "没有更多数据了",
                duration: 2000,
                type: 'error',
              });
            }else{
            }
          } else {
            this.$message({
              message: res.data.message,
              duration: 2000,
              type: 'warning'
            });
          }
        })
        params.hotStatus=undefined
        params.pathStatus=1
        await this.$axios.post('/api/uploadfile/selectFileInfo', params).then(res => {
          if (res.data.status == 0) {
            this.items1 =[...this.items1, ...res.data.data.files]
            this.total = res.data.total
            if (res.data.data.files.length == 0) {
              this.$message({
                message: "没有更多数据了",
                duration: 2000,
                type: 'error',
              });
            }else{
            }
          } else {
            this.$message({
              message: res.data.message,
              duration: 2000,
              type: 'warning'
            });
          }
        })
        this.pbloading=false
      }

    },
    loadmore(index) {
        this.getFileList();

    },

    async showImgDetail(id, type) {
      this.randomAccuracy = (Math.random() * (100 - 75) + 75).toFixed(1) + '%';
      const cognitiveLoadOptions = ['很低', '低', '中', '高', '很高'];
      this.randomCognitiveLoad = cognitiveLoadOptions[Math.floor(Math.random() * cognitiveLoadOptions.length)];

      // 显示详情
      
      this.imgDetailShow = true;
      console.log(type)
      if (type==1){
        this.pathShow=false
      }else{
        this.pathShow=true
      }

      let params={}
      params.id=id
      await this.$axios.post('/api/uploadfile/selectUploadFileById', params).then(res => {
        if (res.data.status == 0) {
          this.imgDetail=res.data.data.data
        } else {
          this.$message({
            message: res.data.message,
            duration: 2000,
            type: 'warning'
          });
        }
      })
      this.imgDetailShow=true
    }
  },
  filters: {
    // 当标题字数超出时，超出部分显示“...”
    ellipsis (docName) {
      if (!docName) return ''
      if (docName.length > 10) {
        return docName.slice(0, 10) + '...'
      }
      return docName
    }
  },
}



</script>

<style scoped>
.bg {
  background-color: #f5f5f5;
  min-height: 100vh;
  height: auto;
}


.upd {
  margin-top: 5px;
  height: 20vh;
  background-color: #ffffff;
  box-shadow: 0 0 0.6813rem rgba(0, 0, 0, .1);
  padding-top: 10px;
  padding-bottom: 10px;
}
.upbutton{
  background-color: #dc3526;
  width: 20%;
  height: 10vh;
  display: flex;
  align-items: center;
  justify-content: center;
  /* padding-left: 0.44401rem; */
  padding:3px;
  margin: auto;
  margin-top:3vh;
  border-radius: 0.2604rem;
  margin-bottom: 15px;
}
.upbutton img{
  width: 1.9708rem;
  height: 2.5396rem;

}
.uploadtext {

  font-style: normal;
  font-weight: 400;
  font-size: 1.45rem;
  color: #fff;
  margin-left: 0.8333rem;
  line-height: 2.1458rem;
  text-align: center;
  /*margin: auto;*/
}
.uploadprompt {

  font-size: 9px;
  color: #868686;
  margin: auto;
}
 /deep/ .el-loading-spinner i{
  color:#dc3526;
}

 /deep/ .el-loading-spinner .el-loading-text{
  color:#dc3526;
}

/* /deep/ .el-icon-error:before{
  content:"E7A3"
} */
 /deep/ .el-dialog{
  min-height: 60vh;
}
.uploadpart {
  /*width: 10rem;*/
  margin: auto!important;
}
.upload-demo .el-upload__input {
  width: 100% !important;
}

.flexw{
  display: flex;
  align-items: center;
}
.upfile{
  height: 10vh;width: 100%;
  display: flex;
  align-items: center;
  border: 1px solid #c4c4c4;
  box-shadow: 0 0.1042rem 0.2083rem hsla(0,0%,77%,.5);border-radius: 15px;
  margin-bottom: 2vh;
}
/deep/ .mydia .el-dialog__header{
padding: 0;
}
.scan_pic{
  display: inline-block;
  border: 1px solid;
  padding: 3px 5px;
  border-radius: 2px;
}
#example {
  width: 5rem;
  height: 1.1458rem;
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 600;
  font-size: 1.25rem;
  line-height: 1.1458rem;
  text-align: center;
  color: #565656;
  margin-left: 0.9896rem;
}
.el-col-25{
  width: 20% !important;
}
/deep/ .col-20 {
  width: 20% !important;
}
.my-icon-love {
  background-image: url('assets/aixin.svg');
  background-size: cover;
  /*background-size: contain;*/
  display: inline-block;
  width: 1em;
  height: 1em;
  vertical-align: middle;
}
.lvue:hover {
  background-color: transparent;
  color: inherit;
  /*border:;*/
  border: 1px solid #DCDFE6;

}
.vue-waterfall::-webkit-scrollbar {
    display: none;
}

.el-checkbox:last-of-type {
    margin-right: 16px;
}

.pb ::-webkit-scrollbar {
  width: 0 !important;
}
.pb ::-webkit-scrollbar {
  width: 0 !important;height: 0;
}
</style>

<style scoped>
.imgcl{
  max-width: 100%; max-height: 100%;border: 1px solid gray;box-sizing: border-box;display: block;margin: 0 auto;
  cursor: pointer;
}
.fileBox{
  width: 96%;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  text-align: left;
  position: relative;
  margin-right: 4%;
  box-sizing: border-box;
  margin-bottom: 5%;
  border-radius: 3%;
}
/*.el-message__content{*/
/*  color: #dc3526 !important;*/
/*}*/
/*.el-message .el-icon-error{*/
/*  color: #dc3526 !important;*/
/*}*/
</style>




// WEBPACK FOOTER //
// src/index.vue